"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  title: {
    fontFamily: "Akkurat, sans-serif",
    "&.h1": {
      fontSize: "1.5em",
      fontWeight: "bold",
      lineHeight: 1.25,
      margin: ".5em 0"
    },
    "&.h2": {
      fontSize: "1.25em",
      fontWeight: "bold",
      lineHeight: 1.25,
      margin: ".5em 0"
    }
  }
}));

const ArticleTitle = ({
  className,
  component = "h1",
  language = "no",
  children
}) => {
  const classes = useStyles();
  const localeId = "locale:" + language;

  if (typeof children === "object") {
    children = children[localeId] || undefined;
  }

  return _react.default.createElement(_Typography.default, {
    className: className || classes.title,
    component: component
  }, children);
};

var _default = ArticleTitle;
exports.default = _default;
module.exports = exports.default;